import { _js } from '@ifixit/utils/localize';
import { Fragment, PropsWithChildren } from 'react';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';

function SchematicThumbnail({
   thumbnailUrl,
   title,
   children,
   onOpen,
   isOpen,
}: PropsWithChildren<
   {
      thumbnailUrl: string;
      title: string;
   } & Pick<MinimalDisclosure, 'onOpen' | 'isOpen'>
>) {
   const altText = title ? _js('Schematic Diagram for %1', title) : _js('Schematic Diagram');

   return (
      <Fragment>
         <button
            onClick={onOpen}
            className="group p-0 m-0 relative float-none sm:float-left w-full sm:w-[178px] h-auto sm:h-[170px] mr-auto sm:mr-2 ml-auto sm:ml-0 mb-2.5 cursor-pointer border border-gray-300 overflow-hidden hover:border-brand-200 transition-all duration-100"
         >
            <img src={thumbnailUrl} alt={altText} className="w-full" />
            <span className="block text-center text-black bg-gray-200/90 font-semibold text-sm absolute w-full bottom-0 m-0 py-2 px-1 group-hover:bg-brand-200 group-hover:py-3 group-hover:px-1 transition-all duration-200">
               {title}
            </span>
         </button>
         {isOpen && children}
      </Fragment>
   );
}

export default SchematicThumbnail;
